export class RoblexModalConfig<D = any> {
    backdrop?: boolean;
    isLeave?: boolean;
    className?: string;
    data?: D;
}
